import { Feature } from '../../core/models/feature.model';

const ActionTypes = {
  GET_LAST_ACTIVE_FEATURE: `[FEATURE] Get Last Active Feature`,
  GET_LAST_ACTIVE_FEATURE_SUCCESS: `[FEATURE] Get Last Active Feature Success`,
  GET_LAST_ACTIVE_FEATURE_FAIL: `[FEATURE] Get Last Active Feature Fail`,

  SAVE_FEATURE_CLOSE: `[FEATURE] Save Feature Close`,
  SAVE_FEATURE_CLOSE_SUCCESS: `[FEATURE] Save Feature Close Success`,
  SAVE_FEATURE_CLOSE_FAIL: `[FEATURE] Save Feature Close Fail`,
};

export class GetLastActiveFeatureAction {
  static type = ActionTypes.GET_LAST_ACTIVE_FEATURE;
}

export class GetLastActiveFeatureSuccessAction {
  static type = ActionTypes.GET_LAST_ACTIVE_FEATURE_SUCCESS;

  constructor(public payload: Feature) {
  }
}

export class GetLastActiveFeatureFailAction {
  static type = ActionTypes.GET_LAST_ACTIVE_FEATURE_FAIL;

  constructor(public payload: any) {
  }
}

export class SaveFeatureCloseAction {
  static type = ActionTypes.SAVE_FEATURE_CLOSE;
}

export class SaveFeatureCloseSuccessAction {
  static type = ActionTypes.SAVE_FEATURE_CLOSE_SUCCESS;
}

export class SaveFeatureCloseFailAction {
  static type = ActionTypes.SAVE_FEATURE_CLOSE_FAIL;

  constructor(public payload: any) {
  }
}
